<template>
  <div>
    <el-card>
      <template slot="header">
        <h5 class="pp-card-title" data-cy="card-title">Servel</h5>
        <p class="pp-card-description"></p>
      </template>

      <chart-party v-if="hasPartido"></chart-party>
      <panel-box v-else></panel-box>
    </el-card>
  </div>
</template>
<script>

import {Card} from "element-ui";
import ChartParty from "@/views/components/ChartParty";
import {mapState} from "vuex";
import PanelBox from "@/views/components/PanelBox";

export default {
  components: {
    PanelBox,
    ChartParty,
    [Card.name]: Card,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      roles: state => state.roles
    }),
    hasPartido() {
      return this.roles.partidoId !== null
    }
  }
}
</script>
